module.exports = __webpack_public_path__ + "img/productBgImg2.594b6ac6.png";